module.exports = __webpack_public_path__ + "static/media/logo.adf4c5f5.png";